import React, { createContext } from 'react';
import Household from 'Classes/Household';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const defaultValue = {
  entity: new Household(),
  update: () => {},
  refresh: () => {},
  folderId: 0,
  primaryClientFirstName: '',
  primaryClientLastName: '',
};

const HouseholdContext = createContext(defaultValue);

export default HouseholdContext;

export const withHousehold = Component => (props) => {
  function alertDeprecated(func) {
    console.trace(); // eslint-disable-line no-console
    alert(`${func} has been deprecated`); // eslint-disable-line no-alert
  }

  const SimpleHouseholdContext = useSimpleHousehold();
  const {
    household,
    householdResource,
    getHousehold,
    householdId,
  } = SimpleHouseholdContext;

  if (household.id < 1) {
    return null;
  }

  return (
    <Component
      household={household}
      householdResource={householdResource}
      updateHousehold={() => alertDeprecated('updateHousehold')}
      refreshHousehold={getHousehold}
      householdId={householdId}
      folderId={household ? household.folderId : null}
      primaryClientFirstName={household ? household.primaryClientFirstName : ''}
      primaryClientLastName={household ? household.primaryClientLastName : ''}
      SimpleHouseholdContext={SimpleHouseholdContext}
      {...props}
    />
  );
};
